import React, { useState } from "react";
import "./question.css";
import { useNavigate } from "react-router-dom";

const Question: React.FC = () => {
  const navigate = useNavigate();

  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!selectedOption) {
      setError("Please select an answer before continuing.");
      return;
    }

    console.log("Selected Answer:", selectedOption);

    // Example: send answer to backend later
    // fetch(`${API_URL}/question/submit`, { method: "POST", body: JSON.stringify({ answer: selectedOption }) });

    // Navigate to next step (e.g. dashboard or next question)
    navigate("/dashboard");
  };

  return (
    <div className="question-container">
      <form className="question-form" onSubmit={handleSubmit}>
        <h2>Cyber Awareness Questionnaire</h2>

        <div className="question-block">
          <p className="question-text">
            1️⃣ How often do you update your software and security patches?
          </p>

          <div className="options-group">
            <label className="option">
              <input
                type="radio"
                name="update"
                value="Always, as soon as updates are available"
                checked={selectedOption === "Always, as soon as updates are available"}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              Always, as soon as updates are available
            </label>

            <label className="option">
              <input
                type="radio"
                name="update"
                value="Occasionally, when I remember"
                checked={selectedOption === "Occasionally, when I remember"}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              Occasionally, when I remember
            </label>

            <label className="option">
              <input
                type="radio"
                name="update"
                value="Rarely or never"
                checked={selectedOption === "Rarely or never"}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              Rarely or never
            </label>
          </div>
        </div>

        {error && <p className="error-text">{error}</p>}

        <button type="submit" className="next-btn">Next</button>
      </form>
    </div>
  );
};

export default Question;
